export const frequencyOptions = [
    {'value':'Daily', 'label': 'Daily'},
    {'value':'Weekly', 'label': 'Weekly'},
    {'value':'Monthly', 'label': 'Monthly'},
    {'value':'Quarterly', 'label': 'Quarterly'},
    {'value':'Annual', 'label': 'Annual'}
]
